import { render, staticRenderFns } from "./appSubmitted.vue?vue&type=template&id=2a5dc448&scoped=true&"
import script from "./appSubmitted.vue?vue&type=script&lang=js&"
export * from "./appSubmitted.vue?vue&type=script&lang=js&"
import style0 from "./appSubmitted.vue?vue&type=style&index=0&id=2a5dc448&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5dc448",
  null
  
)

export default component.exports